module.exports = "https://static.wmbcdn.com/uniweb/images/4370f6bf45e8358821f0bc44c8ebf050.svg";